export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
			ElWidth: null,
			ElScrollWidth: null,
		};
		this.elID = null;
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "sidescroll";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			let elScope = this.$el;
			this.checkSizes();

			window.addEventListener("resize", () => {
				this.checkSizes();
			});

			this.$el.addEventListener("scroll", () => {
				this.checkScroll();
			});
			this.checkScroll();

			if (this.$el.parentNode.querySelector(".button-scroller")) {
				this.navButtons();
			}
		}
	}
	checkSizes() {
		this.ElWidth = this.$el.offsetWidth;
		this.ElScrollWidth = this.$el.scrollWidth;
		// console.log(this.ElWidth, this.ElScrollWidth);

		if (this.ElWidth < this.ElScrollWidth) {
			this.$el.classList.add("is-scrollable");
		} else {
			this.$el.classList.remove("is-scrollable");
		}
	}

	checkScroll() {
		if (this.$el.scrollLeft === 0) {
			this.$el.classList.add("left");
		} else {
			this.$el.classList.remove("left");
		}

		if (this.$el.scrollLeft + this.ElWidth >= this.ElScrollWidth - 30) {
			this.$el.classList.add("right");
		} else {
			this.$el.classList.remove("right");
		}
	}
	navButtons() {
		this.$el.parentNode
			.querySelectorAll(".button-scroller")
			.forEach((elButton) => {
				elButton.addEventListener("click", (e) => {
					e.preventDefault();
					if (elButton.classList.contains("scroller-left")) {
						this.$el.scrollLeft -= this.ElWidth * 0.5;
					} else {
						this.$el.scrollLeft += this.ElWidth * 0.5;
					}
				});
			});
	}
}
